<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Tarifarios</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">Tarifarios</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-6 pt-2 pb-2">
                <h5 class="mb-0">Formulario {{ accion }} Tarifarios</h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-AsignacionTarifa"
                    data-toggle="tab"
                    href="#AsignacionTarifa"
                    v-if="
                      form.id &&
                        $store.getters.can(
                          'hidrocarburos.tarifarios.tarifaShow'
                        )
                    "
                    >Asignación de Tarifas</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group col-md-3">
                        <label>Nombre</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.nombre"
                          :class="
                            $v.form.nombre.$invalid ? 'is-invalid' : 'is-valid'
                          "
                          :disabled="
                            !$store.getters.can('hidrocarburos.tarifarios.edit')
                          "
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Empresa</label>
                        <v-select
                          v-model="empresa"
                          placeholder="Empresa"
                          label="razon_social"
                          :options="listasForms.empresas"
                          @search="buscarEmpresa"
                          @input="selectEmpresa()"
                          :class="[
                            $v.form.empresa_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                            'form-control form-control-sm p-0',
                          ]"
                          :disabled="form.estado == 2"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-2">
                        <label>Estado</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.estado"
                          :class="
                            $v.form.estado.$invalid ? 'is-invalid' : 'is-valid'
                          "
                          :disabled="
                            form.estado == 2 ||
                              !$store.getters.can(
                                'hidrocarburos.tarifarios.edit'
                              )
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label>Usuario</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          :value="user.nombre"
                          disabled
                        />
                        <input
                          v-model="form.user_id"
                          type="hidden"
                          class="form-control form-control-sm p-0"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="observaciones">Observaciones</label>
                        <br />
                        <textarea
                          vtype="date"
                          class="form-control"
                          id="fecha_final"
                          v-model="form.observaciones"
                          rows="2"
                          :class="
                            $v.form.observaciones.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          :disabled="
                            !$store.getters.can('hidrocarburos.tarifarios.edit')
                          "
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="row justify-content-center">
                      <button class="btn bg-secondary" @click="back()">
                        <i class="fas fa-reply"></i> Volver
                      </button>
                      <button
                        class="btn bg-primary ml-2"
                        v-show="!$v.form.$invalid"
                        @click="save()"
                      >
                        <i class="fas fa-paper-plane"></i>Guardar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="AsignacionTarifa">
                  <TarifasTarifario ref="tarifasTarifario" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import TarifasTarifario from "./TarifasTarifario";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";

export default {
  name: "TarifarioForm",
  components: {
    vSelect,
    Loading,
    TarifasTarifario,
  },
  data() {
    return {
      accion: "Crear",
      metodo: "POST",
      empresa: null,
      cargando: false,
      form: {
        id: null,
        nombre: null,
        estado: 1,
        empresa_id: null,
        observaciones: null,
        user_id: this.accion == "Crear" ? this.$store.getters.getUser.id : null,
      },
      user: {
        id: null,
        nombre: null,
      },
      listasForms: {
        estados: [],
        empresas: [],
      },
    };
  },
  validations: {
    form: {
      nombre: {
        required,
      },
      empresa_id: {
        required,
      },
      estado: {
        required,
      },
      observaciones: {
        required,
      },
    },
  },
  methods: {
    getIndex() {
      this.cargando = true;
      this.accion = this.$route.params.accion;
      if (this.$route.params.accion == "Editar") {
        this.getForm();
        this.$refs.tarifasTarifario.cargarTarifas();
        this.metodo = "PUT";
        this.cargando = false;
      } else {
        this.form.user_id = this.$store.getters.getUser.id;
        this.user = {
          id: this.$store.getters.getUser.id,
          nombre: this.$store.getters.getUser.name,
        };
        this.cargando = false;
      }
      this.cargando = false;
    },

    getForm() {
      this.form = {
        id: this.$route.params.data_edit.id,
        nombre: this.$route.params.data_edit.nombre,
        empresa_id: this.$route.params.data_edit.empresa_id,
        estado: this.$route.params.data_edit.estado,
        observaciones: this.$route.params.data_edit.observaciones,
        user_id: this.$route.params.data_edit.user.id,
      };
      this.user = {
        id: this.$route.params.data_edit.user.id,
        nombre: this.$route.params.data_edit.user.name,
      };
      this.empresa = {
        id: this.$route.params.data_edit.empresa_id,
        razon_social: this.$route.params.data_edit.empresa.razon_social,
      };
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    buscarEmpresa(search, loading) {
      if (search) {
        loading(true);
        axios
          .get("/api/admin/empresas/lista", { params: { search } })
          .then((response) => {
            let respuesta = response.data;
            this.listasForms.empresas = respuesta;
            loading(false);
          })
          .catch((error) => {
            loading(false);
            this.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    selectEmpresa() {
      this.form.empresa_id = null;
      if (this.empresa) {
        this.form.empresa_id = this.empresa.id;
      }
    },

    save() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        axios({
          method: this.metodo,
          url: "/api/hidrocarburos/tarifarios",
          data: this.form,
        })
          .then((response) => {
            this.cargando = false;
            this.form = response.data;
            this.$route.params.accion = "Editar";
            this.$swal({
              icon: "success",
              title: "El tarifario se guardó exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            // Actualizar componente de tarifas si existe
            if (
              this.$refs.tarifasTarifario &&
              this.$refs.tarifasTarifario.$refs.tarifasTarifario
            ) {
              this.$refs.tarifasTarifario.$refs.tarifasTarifario.limpiarFormulario();
            }
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo... " + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          });
      }
    },

    back() {
      return this.$router.replace({ path: "/Hidrocarburos/Tarifarios" });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
  },
};
</script>
